//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeaderTopToBr',
  methods: {
    toBr () {
      window.location.href = 'https://pagsmile.com.br/'
    }
  }
}
